// extracted by mini-css-extract-plugin
export var active = "_kz-e";
export var blink = "_kz-f";
export var dropDownSelector = "_kz-5";
export var dropDownWrapper = "_kz-4";
export var fakeCursor = "_kz-d";
export var fontSizeButton = "_kz-7";
export var formQuillEditor = "_kz-0";
export var pressed = "_kz-g";
export var qlBlank = "_kz-1";
export var textFormattingToolbar = "_kz-2";
export var textFormattingToolbarClosed = "_kz-3";
export var textFormattingToolbarInline = "_kz-6";
export var textToolbarOption = "_kz-8";
export var toolbarCell = "_kz-a";
export var toolbarCellCollapsed = "_kz-b";
export var toolbarOptionHitArea = "_kz-c";
export var toolbarOverflow = "_kz-9";